<template>
    <section>
      <title>User | Beta Features</title>
      <div class="box">
        <div class="section-title">
          <b>Beta Features</b>
        </div>
  
          <div class="section-loader" v-if="!loaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>
          <div v-if="loaded">
          <p class="text-info vertical-margin-medium">If you want to test beta features, message a developer in the <a href="https://discord.gg/MvxYP4S" class="link">discord support server</a>.</p>
          
          <ul class="beta-feature-list">
            <div v-for="feature in beta_feature_list" v-bind:key="feature.flag" class="beta-feature-container">
              <div class="beta-feature-title-container">
                <li>{{ feature.title  }}</li>
                <i class="fas fa-check-circle green-icon" v-if="beta_features.includes(feature.flag)"></i><i class="fas fa-times-circle red-icon" v-else></i>
              </div>
              <div class="beta-feature-info">
                <li class="beta-feature-description">{{ feature.description }}</li>
                <li class="beta-feature-meta"><i class="fas fa-info-circle"></i> {{ feature.meta  }}</li>
              </div>
              <Button v-if="feature.public" @click="toggleFlag(feature.flag)" :loading="loadingFlags.includes(feature.flag)" :background="beta_features.includes(feature.flag) ? 'var(--red)' : 'var(--green)'" color="var(--white)" :text="beta_features.includes(feature.flag) ? 'Disable Feature' : 'Enable Feature'" />
            </div>
          </ul>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex";
  import Button from "@/components/Button.vue";
  import StatusCodes from "../utils/ResponseCodes";

  export default {
    name: "Beta Features",
    data () {
      return {
        loaded: false,
        beta_feature_list: [],
        loadingFlags: []
      };
    },
    components: { Button },
    watch: {
      login_queried () {
        this.loadFeatures();
      }
    },
    mounted () {
      if (this.login_queried) this.loadFeatures();
    },
    computed: {
      ...mapGetters(["id", "login_queried", "guilds", "beta_features"])
    },
    methods: {
      async loadFeatures () {
        const betaFeatures = await this.$rest.api.information.beta.get().then(response => response.payload).catch(() => {});
        if (betaFeatures) {
          this.beta_feature_list = betaFeatures;
          this.loaded = true;
        }
      },
      async toggleFlag (flag) {
        this.loadingFlags.push(flag);
        await this.$rest.api.users(this.id).features.post({
          query: {
            action: this.beta_features.includes(flag) ? "remove" : "add",
            flag
          }
        }).catch(() => {});
        this.loadFeatures();
        const userPayload = await this.$rest.api.users("@me").get({ query: { with_guilds: true } }).then((response) => response.payload).catch(() => {});
        if (userPayload.status_code === StatusCodes.SUCCESS && userPayload.found) this.storeUser(userPayload);
        this.loadingFlags.splice(this.loadingFlags.find(flg => flg === flag), 1)
      },
      ...mapActions(["storeUser"])
    }
  }
  </script>
  
<style scoped>
.vertical-margin-medium {
  margin: 1.5em 0;
}

table {
  overflow-y: scroll;
}

.beta-feature-title-container {
  font-size: 1.5em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.beta-feature-list {
  display: flex;
}

.beta-feature-info {
  margin: 0.3em 0;
}

.beta-feature-meta {
  margin-top: 0.7em;
}

.beta-feature-info {
  margin: .5em 0;
}

.beta-feature-description {
  color: var(--grey);
}

.beta-feature-meta {
  color: var(--golden);
  font-size: 0.85em;
}

.beta-feature-container {
  background-color: var(--light-grey-blue);
  padding: 1em;
  margin: 0.5em;
  border-radius: 0.3em;
  box-shadow: 5px 5px 25px 5px rgba(0,0,0,.5);
  max-width: 35em;
}

</style>